import React, {FunctionComponent} from 'react';
import colors from 'src/integration/styles/colors';
import styled, { css } from 'styled-components';
import Icon from "src/presentation/components/ui/Icon";
import { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import ErrorText from "src/presentation/components/ErrorText";

interface ComponentProps<T extends FieldValues> {
  name: Path<T>;
  placeholder?: string;
  register: UseFormRegister<T>;
  type: string;
  errors?: string;
  defaultValue?: string;
  leftIcon?: FunctionComponent<SimpleObject>;
  rightIcon?: FunctionComponent<SimpleObject>;
}

const Root = styled.div`
  ${() => css`
      display: flex;
      align-items: flex-start;
      flex-direction: column;
  `}
`;

const InputFieldWrapper = styled.div`
  ${() => css`
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border: 1px solid ${colors.grey4};
      padding: 8px 16px;
      border-radius: 100px;
      width: 100%;
      background: ${colors.primaryWhite};
  `}
`;

const InputField = styled.input`
  ${() => css`
      border: none;
      outline: none;
      flex: 1;
      padding: 0.5rem;
  `}
`;

const StyledIcon = styled(Icon)`
  ${() => css`
      color: ${colors.grey3};
  `}
`;

const Input = <T extends FieldValues>({
                                        name,
                                        register,
                                        type,
                                        placeholder,
                                        errors,
                                        leftIcon, rightIcon
                                      }: ComponentProps<T>) => {
  return (
      <Root>
          <InputFieldWrapper>
              {leftIcon && <StyledIcon icon={leftIcon} size={24}/>}
              <InputField id={name} type={type} placeholder={placeholder} {...register(name)} />
              {rightIcon && <StyledIcon icon={rightIcon} size={24}/>}
          </InputFieldWrapper>
        {errors && <ErrorText error={errors} />}
      </Root>
  );
};

export default Input;
